export const RIY_FEE_FIELDS = [
  ['productFeePercent', 'Annual product fee (%)'],
  ['fundFeePercent', 'Annual fund fee (%)'],
  ['adviserOngoingFeePercent', 'Annual adviser ongoing fee (%)'],
  ['initialFeePercent', 'One-off initial fee (%)'],
  ['investmentTermYears', 'Fee averaging investment term (years)'],
];
export const REDUCTION_IN_YIELD = {
  endpoint: '/api/calculators/reduction-in-yield/calculate',
  fields: ['productFeePercent', 'fundFeePercent', 'adviserOngoingFeePercent', 'initialFeePercent', 'investmentTermYears'],
  subject: 'reduction in yield estimate',
  initialMessage: 'Enter annual fees, the one-off initial fee and the investment term.',
  validationMessage: 'Enter a finite numeric value. Enter zero if a fee does not apply.',
  successMessage: 'Fee-based reduction in yield calculated.',
  example: [0.3, 0.5, 0.75, 3, 10],
  exampleMessage: 'Example loaded: 0.30% product + 0.50% fund + 0.75% adviser + (3% initial ÷ 10 years).',
  outputLabels: { ongoingFeesPercent: 'Ongoing fees', annualisedInitialFeePercent: 'Annualised initial fee', reductionInYieldPercent: 'Reduction in yield', reductionInYieldRate: 'Reduction in yield rate' },
};
